<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import PersonalAccidentData from '@/data/company-page-data/groupama-sigorta/cross-pages/PersonalAccidentInsurance'
export default {
  metaInfo: {
    title: 'Groupama Sigorta Ferdi Kaza Poliçesi İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'Sizi ve sevdiklerinizi güvence altına alan Groupama Sigorta Ferdi Kaza Sigortası ile gelecekteki riskler korunuyor. En doğru planı seçmek için tıklayınız.'
      }
    ]
  },
  name: 'GroupamaSigortaPersonalAccident',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: PersonalAccidentData.headerContent,
      crossPageContent: PersonalAccidentData.crossPageContent,
      faqTitle: PersonalAccidentData.faqTitle,
      faqTitleDesc: PersonalAccidentData.faqTitleDesc,
      getPrice: PersonalAccidentData.getPrice
    }
  }
}
</script>
